import React from 'react'
import { Outlet } from 'react-router-dom'

import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import Header from './Header'
import Sidebar from './Sidebar'

export type LandingLayoutProps = {}

export default function LandingLayout(props: LandingLayoutProps) {
  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })

  return (
    <Box sx={{ height: '100%', backgroundColor: (theme) => theme.palette.background.default }}>
      <Stack direction="row">
        {!isMobileScreen && <Sidebar />}
        <Stack minHeight="100vh" sx={{ flex: 1, position: 'relative', overflow: 'auto' }}>
          <Header />
          <Outlet />
        </Stack>
      </Stack>
    </Box>
  )
}
